var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack355({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 2.96,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.24,10.74V5.37H7.76a3.06,3.06,0,0,1,.86.1,1.47,1.47,0,0,1,.67.47,2.67,2.67,0,0,1,.44.86A4.45,4.45,0,0,1,9.88,8a4.19,4.19,0,0,1-.26,1.55,1.93,1.93,0,0,1-.69.9,2.11,2.11,0,0,1-1.1.26Zm.59-.63h.93a1.54,1.54,0,0,0,.86-.19,1.1,1.1,0,0,0,.45-.59A3.67,3.67,0,0,0,9.28,8a3,3,0,0,0-.22-1.28,1.27,1.27,0,0,0-.57-.63A2,2,0,0,0,7.75,6H6.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack355);
export default __webpack_public_path__ + "static/media/Symbol_pack_355.8fe0bb15a84d162430da808bde18dd90.svg";
export { ForwardRef as ReactComponent };